import { Component, Input, OnInit, SimpleChanges } from "@angular/core"
import { Subscription } from "rxjs"
import { FacetingService } from "../../../services/faceting.service"
import { SearchingService } from "../../../services/searching.service"
import { Facet, FacetNode } from "../../../models/facet.model"
import { BaseNode, CHNode } from "../../../models/node.model"
import { facetType } from "../../../utils/types"

@Component({
    selector: "app-nested-facet",
    templateUrl: "./nested-facet.component.html",
    styleUrls: ["./nested-facet.component.less"],
})
export class NestedFacetComponent implements OnInit {
    @Input() public facetId: string
    @Input() public isCollapsed: boolean = true
    @Input() public premiumCollectionSearch: boolean = false
    @Input() public syncFacets: boolean = false
    @Input() public title: string

    private facet: Facet<BaseNode> = null
    public selectedFiltersCount: number = 0
    public subscriptions: Subscription[] = []
    public topLevel: FacetNode[] = []

    constructor(private facetingService: FacetingService) {}

    public ngOnInit() {
        this.subscribeToFilterCount()
        if (this.syncFacets) {
            this.isCollapsed = true
            this.syncCollapseStateForMobile()
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes["facetId"]) {
            this.initializeNestedFacet()
        }
    }

    private initializeNestedFacet() {
        this.subscriptions.push(
            this.facetingService.nestedFacetsChanged.subscribe(
                (facets: Record<string, Facet<BaseNode>>) => {
                    this.facet = facets[this.facetId]
                    this.topLevel = this.facet && this.facet.topLevel()
                }
            )
        )
    }

    private subscribeToFilterCount() {
        this.subscriptions.push(
            this.facetingService.filtersChanged.subscribe((selectedFilters) => {
                if (this.facet) {
                    this.selectedFiltersCount = selectedFilters.filter(
                        (filter) =>
                            Object.keys(this.facet.facetNodes).find(
                                (f) => f === filter.replace(":", "-")
                            )
                    ).length
                }
            })
        )
    }

    private syncCollapseStateForMobile() {
        this.subscriptions.push(
            this.facetingService.toggleFilter.subscribe(
                (facetType: facetType) => {
                    this.isCollapsed = true
                    if (facetType.type === this.facetId) {
                        this.isCollapsed = facetType.state
                    }
                }
            )
        )
    }

    public onToggle() {
        this.isCollapsed = !this.isCollapsed
        if (this.syncFacets) {
            this.facetingService.broadcastOnToggle(
                this.isCollapsed,
                this.facetId
            )
        }
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
